import styled, { css } from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  margin-bottom: 16px;
  width: 100%;
`;

export const SecurityReminderWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  svg {
    width: 10px;
    height: 15px
  }
`;

export const SecurityReminder = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    text-align: center;
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex: 1;
    gap: 20px;
    margin-top: 24px;
    padding: 0 32px 0 32px; 
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      padding: 0 20px 0 20px;
    }
  `}
`;

export const PaymentAccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PaymentInformation = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    padding-bottom: 24px;
  `}
`;

export const RenewalInformation = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    max-width: 545px;
    padding-top: 10px;
    span {
      font-weight: ${theme.v2.font.weights.medium};
    }
    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: unset;
    }
  `}
`;

export const Cart = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    padding: 32px 24px;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 2;
      padding: 0;
    }
  `}
`;

export const Resume = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    max-width: 30%;
    padding: 32px 24px;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.lg}) {
      max-width: 409px;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 1;
      max-width: unset;
      padding: 0;
    }
  `}
`;

export const CartTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0 0 24px 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
      margin: 0 0 16px 0;
    }
  `}
`;

export const ResumeTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0 0 24px 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
      margin: 0 0 16px 0;
    }
  `}
`;

export const ProductDetailsBox = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;
  `}
`;

export const ProductTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0 0 16px 0;
  `}
`;

export const ProductNameWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    gap: 8px;
    margin: 8px 0 16px 0;
    padding-bottom: 16px;
  `}
`;

export const ProductIcon = styled.img``;


export const ProductName = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0px;
  `}
`;

export const ProductBasePrice = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    text-decoration: line-through;
  `}
`;

export const ProductBasePriceWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const BasePriceWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-bottom: 8px;
`;

export const ProductFinalPriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 8px 0;
  width: 100%;
`;

export const ProductFinalPrice = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const ProductRenewal = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const TagWrapper = styled.div`
  ${({ theme }) => css`
    div {
      background-color: ${theme.v2.colors.neutral.primaryLowLight};
    }
  `}
`;

export const AccordionWrapper = styled.div`
  ${({ theme }) => css`
    > div {
      @media (max-width: ${theme.v2.breakpoints.md}) {
        padding: 8px 0px 8px 0px;
      }
      > div:first-child {
        padding: 32px 24px 12px 24px;
        @media (max-width: ${theme.v2.breakpoints.md}) {
          padding: 24px 20px 4px 20px;
        }
      }
      > div {
        @media (max-width: ${theme.v2.breakpoints.md}) {
          div:nth-child(2) {
            padding-top: 0;
          }
          margin: 0;
          padding-left: 20px;
          padding-right: 20px;
        }
      }
    }
  `}
`;

export const TaxesWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 0 16px 0;
  padding: 0;
`;

export const ProductTaxWrapper = styled.li`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ProductTax = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    gap: 4px;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const IconInfoWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

export const TaxToolTipTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0 0 16px 0;
  `}
`;

export const TaxToolTipContent = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const TaxToolTipWrapper = styled.div`
  padding: 16px;
  max-width: 361px;
`;

export const TaxToolTipList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0 0 24px;
  padding: 0;
`;

export const TaxToolTipListItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;
